//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: { type: String, required: true },
    imgSrc: { type: String, required: true },
    imgAlt: { type: String, default: '' }
  },
  computed: {
    resolvedImgSrc() {
      return require(`~/assets/${this.imgSrc}`);
    }
  }
};
